import script from "./dashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./dashboard.vue?vue&type=script&setup=true&lang=js"

import "./dashboard.vue?vue&type=style&index=0&id=57a255a3&lang=css"
import "./dashboard.vue?vue&type=style&index=1&id=57a255a3&lang=css"

const __exports__ = script;

export default __exports__